<template>
	<div>
		<a-page-header style="background: #fff;" title="优惠券管理" :breadcrumb="{props:{routes:[{breadcrumbName:'首页'},{breadcrumbName:'优惠券管理'}]}}">
			<template slot="extra">
				<a-button type="primary" @click="addModal = true">
					添加优惠券
				</a-button>
			</template>
		</a-page-header>

		<!-- 列表 -->
		<div class="mainBox">
			<div class="contentBox">
				<a-table :columns="columns" :dataSource="list" rowKey="id" :pagination="pagination" :loading="loading" @change="handleTableChange">
					<span slot="couponName" slot-scope="couponName">
						<strong>{{couponName}}</strong>
					</span>	
					<span slot="couponType" slot-scope="couponType">
						<a-tag color="blue">{{couponType}}</a-tag>
					</span>	
					<span slot="couponAcount" slot-scope="text, couponAcount">
						<div><span class="text-gray">总发放</span> {{couponAcount.couponAll == -1 ? '不限制' : couponAcount.couponAll}}</div>
						<div><span class="text-gray">每人限领</span> {{couponAcount.couponEvery == -1 ? '不限制' : couponAcount.couponEvery}}</div>
						<div><span class="text-gray">已领取</span> {{couponAcount.hasReceiveNum}}</div>
						<div><span class="text-gray">已使用</span> {{couponAcount.hasUsedNum}}</div>
						<div><span class="text-gray">未使用</span> {{couponAcount.unHasUsedNum}}</div>
					</span>
					<span slot="couponDate" slot-scope="text, couponDate">
						{{couponDate.couponBegin}} 至 {{couponDate.couponEnd}}
					</span>
					<span slot="action" slot-scope="text, record">
						<a @click="edit(record.id)">详情</a>
					<!-- 	<a-divider type="vertical" />
						<a @click="toGetList(record.id)">领取记录</a> -->
						<a-divider type="vertical" />
						<a-popconfirm title="请确认是否删除？" okText="是" cancelText="否" @confirm="del(record.id)">
							<a href="javascript:;" style="color: #ff4d4f;">删除</a>
						</a-popconfirm>
					</span>
				</a-table>
			</div>
		</div>

		<!-- 添加优惠券弹出 -->
		<a-modal title="添加优惠券" v-model="addModal" @ok="addSubmit" cancelText="取消" okText="添加" width="50%">
			<a-form-model ref="addForm" :model="addForm" :rules="addRules" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-form-model-item label="优惠券名称" prop="couponName">
					<a-input v-model="addForm.couponName"></a-input>
				</a-form-model-item>
				<a-form-model-item label="优惠券类型" prop="couponType">
					<a-radio-group button-style="solid" v-model="addForm.couponType">
						<a-radio-button :value="1">
							满减券
						</a-radio-button>
						<a-radio-button :value="2">
							折扣券
						</a-radio-button>
					</a-radio-group>
				</a-form-model-item>
				<template v-if="addForm.couponType == 1">
					<a-form-model-item label="满足" prop="couponFull">
						<a-input v-model="addForm.couponFull" style="width: 200px;" suffix="元"></a-input>
					</a-form-model-item>
					<a-form-model-item label="减免" prop="couponCut">
						<a-input v-model="addForm.couponCut" style="width: 200px;" suffix="元"></a-input>
					</a-form-model-item>
				</template>
				<template v-if="addForm.couponType == 2">
					<a-form-model-item label="折扣" prop="couponDiscount">
						<a-input v-model="addForm.couponDiscount" style="width: 200px;" suffix="折"></a-input>
					</a-form-model-item>
				</template>
				<a-form-model-item label="发放数量" prop="couponAll">
					<a-input v-model="addForm.couponAll" style="width: 200px;" suffix="张" />
					<div style="color: #ff7a45;">如不限制数量请填写-1</div>
				</a-form-model-item>
				<a-form-model-item label="每人限领数量" prop="couponEvery">
					<a-input v-model="addForm.couponEvery" style="width: 200px;" suffix="张" />
					<div style="color: #ff7a45;">如不限制数量请填写-1</div>
				</a-form-model-item>
				<a-form-model-item label="使用时限" prop="couponDate">
					<a-range-picker :locale="locale" v-model="addForm.couponDate" :show-time="{hideDisabledOptions: true,defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('11:59:59', 'HH:mm:ss')],}"
					 format="YYYY-MM-DD HH:mm:ss" required />
				</a-form-model-item>
			</a-form-model>
		</a-modal>

		<!-- 编辑优惠券弹出 -->
		<a-modal title="编辑优惠券" v-model="editModal" @ok="editSubmit" cancelText="取消" okText="保存" width="50%">
			<a-form-model ref="editForm" :model="editForm" :rules="addRules" :label-col="labelCol" :wrapper-col="wrapperCol">
				<a-form-model-item label="优惠券名称" prop="couponName">
					<a-input v-model="editForm.couponName"></a-input>
				</a-form-model-item>
				<a-form-model-item label="优惠券类型" prop="couponType">
					<a-radio-group button-style="solid" v-model="editForm.couponType">
						<a-radio-button :value="1">满减券</a-radio-button>
						<a-radio-button :value="2">折扣券</a-radio-button>
					</a-radio-group>
				</a-form-model-item>
				<template v-if="editForm.couponType == 1">
					<a-form-model-item label="满足" prop="couponFull">
						<a-input v-model="editForm.couponFull" style="width: 200px;" suffix="元"></a-input>
					</a-form-model-item>
					<a-form-model-item label="减免" prop="couponCut">
						<a-input v-model="editForm.couponCut" style="width: 200px;" suffix="元"></a-input>
					</a-form-model-item>
				</template>
				<template v-if="editForm.couponType == 2">
					<a-form-model-item label="折扣" prop="couponDiscount">
						<a-input v-model="editForm.couponDiscount" style="width: 200px;" suffix="折"></a-input>
					</a-form-model-item>
				</template>
				<a-form-model-item label="发放数量" prop="couponAll">
					<a-input v-model="editForm.couponAll" style="width: 200px;" suffix="张" />
					<div style="color: #ff7a45;">如不限制数量请填写-1</div>
				</a-form-model-item>
				<a-form-model-item label="每人限领数量" prop="couponEvery">
					<a-input v-model="editForm.couponEvery" style="width: 200px;" suffix="张" />
					<div style="color: #ff7a45;">如不限制数量请填写-1</div>
				</a-form-model-item>
				<a-form-model-item label="使用时限" required>
					<a-range-picker :locale="locale" :default-value="[moment(editForm.couponBegin,'YYYY-MM-DD HH:mm:ss'),moment(editForm.couponEnd,'YYYY-MM-DD HH:mm:ss')]"
					 :show-time="{hideDisabledOptions: true,defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],}"
					 format="YYYY-MM-DD HH:mm:ss" @change="editDateChange" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
	</div>
</template>

<script>
	import moment from "moment"
	import 'moment/locale/zh-cn'
	import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
	const columns = [{
			title: 'ID',
			dataIndex: 'id',
		},
		{
			title: '优惠券名称',
			dataIndex: 'couponName',
			scopedSlots: {
				customRender: 'couponName'
			},
		},
		{
			title: '优惠券类型',
			dataIndex: 'couponType',
			scopedSlots: {
				customRender: 'couponType'
			},
		},
		{
			title: '优惠内容',
			dataIndex: 'couponCont',
			scopedSlots: {
				customRender: 'couponCont'
			},
		},
		{
			title: '有效期',
			dataIndex: 'couponDate',
			scopedSlots: {
				customRender: 'couponDate'
			},
		},
		{
			title: '数量',
			dataIndex: 'couponAcount',
			scopedSlots: {
				customRender: 'couponAcount'
			},
		},
		{
			title: '添加时间',
			dataIndex: 'addTime',
		},
		{
			title: '操作',
			dataIndex: 'action',
			scopedSlots: {
				customRender: 'action'
			},
		},
	];

	export default {
		data() {
			return {
				moment,
				locale,
				columns,
				couponId: '',
				list: [],
				actList: [],
				labelCol: {
					span: 5
				},
				wrapperCol: {
					span: 14
				},
				pagination: {
					pageSize: 20,
					total: 0,
					current: 1
				},
				addForm: {
					couponAll: -1,
					couponEvery: -1,
					couponDate: undefined,
				},
				editForm: {},
				addModal: false,
				editModal: false,
				loading: false,
				addRules: {
					couponName: [{
						required: true,
						message: '请填写活动名称',
						trigger: 'blur'
					}],
					couponType: [{
						required: true,
						message: '请选择优惠券类型',
						trigger: 'change'
					}],
					couponAll: [{
						required: true,
						message: '请填写发放数量',
						trigger: 'blur'
					}],
					couponFull: [{
						required: true,
						message: '请填写满足金额',
						trigger: 'blur'
					}],
					couponCut: [{
						required: true,
						message: '请填写减免金额',
						trigger: 'blur'
					}],
					couponDiscount: [{
						required: true,
						message: '请填写折扣',
						trigger: 'blur'
					}],
					couponEvery: [{
						required: true,
						message: '请填写每人限领数量',
						trigger: 'blur'
					}],
					couponDate: [{
						required: true,
						message: '请选择使用时限',
						trigger: 'change'
					}],
				},
			};
		},

		mounted() {
			this.id = this.$route.query.id
			this.getList()
			this.getActList()
		},

		methods: {
			toDetail(id) {
				this.$router.push('/activityDetail?id=' + id)
			},

			toGetList(id) {
				this.$router.push('/couponGetList?id=' + id)
			},
			
			editDateChange(value){
				console.log(value)
				this.editForm.couponBegin = moment(value[0]).format('YYYY-MM-DD HH:mm:ss')
				this.editForm.couponEnd = moment(value[1]).format('YYYY-MM-DD HH:mm:ss')
			},
			
			edit(id) {
				this.couponId = id
				this.$http.post('/admin/index.php/admin/Acit/couponInfo', {
					id: id
				}).then(res => {
					if (res.data.code == 1) {
						this.editForm = res.data.data
						var date = []
						date.push(res.data.data.couponBegin)
						date.push(res.data.data.couponEnd)
						this.editForm.couponDate = date
						console.log(this.editForm.couponDate)
						this.editModal = true
					}
				})
			},

			editSubmit() {
				this.$refs.editForm.validate(valid => {
					if (valid) {
						this.$http.post('/admin/index.php/admin/Acit/couponAdd', {
							id: this.couponId,
							couponName: this.editForm.couponName,
							couponType: this.editForm.couponType,
							couponFull: this.editForm.couponFull,
							couponCut: this.editForm.couponCut,
							couponDiscount: this.editForm.couponDiscount,
							couponAct: this.editForm.couponAct,
							couponAll: this.editForm.couponAll,
							couponEvery: this.editForm.couponEvery,
							couponBegin: this.editForm.couponBegin,
							couponEnd: this.editForm.couponEnd,
						}).then(res => {
							if (res.data.code == 1) {
								this.$message.success('保存成功！');
								this.editModal = false
								this.getList()
							} else {
								this.$message.error(res.data.msg);
							}
						})
					}
				});
			},

			addSubmit() {
				this.$refs.addForm.validate(valid => {
					if (valid) {
						this.$http.post('/admin/index.php/admin/Acit/couponAdd', {
							couponName: this.addForm.couponName,
							couponType: this.addForm.couponType,
							couponFull: this.addForm.couponFull,
							couponCut: this.addForm.couponCut,
							couponDiscount: this.addForm.couponDiscount,
							couponAct: this.addForm.couponAct,
							couponAll: this.addForm.couponAll,
							couponEvery: this.addForm.couponEvery,
							couponBegin: moment(this.addForm.couponDate[0]).format('YYYY-MM-DD HH:mm:ss'),
							couponEnd: moment(this.addForm.couponDate[1]).format('YYYY-MM-DD HH:mm:ss'),
						}).then(res => {
							if (res.data.code == 1) {
								this.$message.success('添加成功！');
								this.addModal = false
								this.getList()
							} else {
								this.$message.error(res.data.msg);
							}
						})
					}
				});
			},

			del(id) {
				this.$http.post('/admin/index.php/admin/Acit/couponDel', {
					id: id
				}).then((res) => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.getList();
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			handleTableChange(pagination, filters, sorter) {
				this.list = []
				this.pagination.current = pagination.current
				this.getList()
			},

			getList() {
				this.loading = true
				var data = {
					hid:this.id,
					page: this.pagination.current,
					num: this.pagination.pageSize,
				}
				this.$http.post('/admin/index.php/admin/Acit/couponList', data).then(res => {
					this.loading = false
					if (res.data.code == 1) {
						this.list = res.data.data
						this.pagination.total = res.data.count
					} else {
						this.$message.error(res.data.msg);
					}
				})
			},

			getActList() {
				this.$http.get('/admin/index.php/admin/Acit/pullList').then(res => {
					if (res.data.code == 1) {
						this.actList = res.data.data
					}
				})
			},
		}
	}
</script>

<style scoped="">
</style>
